<template>
  <div class="flex h-full flex-col items-start">
    <template v-if="hasNoImage">
      <img alt="no-image" class="h-full w-full object-cover" src="@/assets/img/no-image.svg" />
    </template>
    <template v-else>
      <ImageMediaSlider
        v-if="hasMultipleImages"
        :class="['h-full w-full object-cover', multiColumnLayout && 'md:aspect-[4/5]']"
        :pc-optimized-image-options="{ width: IMAGE_MEDIA_WIDTH }"
        :slides="slides"
        :sp-optimized-image-options="{ width: IMAGE_MEDIA_WIDTH }"
      />
      <!-- 単一画像。SP/PC 出し分け・最適化は OptimizedImage が担当（JS の isSP で src を差し替えない） -->
      <OptimizedImage
        v-else
        :class="['h-full w-full object-cover', multiColumnLayout && 'md:aspect-[4/5]']"
        :pc-image-url="slides[0].pc"
        :pc-optimized-image-options="{ width: IMAGE_MEDIA_WIDTH }"
        :sp-image-url="slides[0].sp"
        :sp-optimized-image-options="{ width: IMAGE_MEDIA_WIDTH }"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { buildResponsiveImageSlides } from '@/utils/wabunka/image/responsiveImageSlides';
import { OptimizedImage } from '@/wabunka-src/common/components';
import { ImageMediaSlider } from '@/wabunka-src/common/features';

const props = withDefaults(
  defineProps<{
    pcImages: string[];
    spImages: string[];
    multiColumnLayout?: boolean;
  }>(),
  { multiColumnLayout: false },
);

// 最適化(format=auto/リサイズ)は OptimizedImage / ImageMediaSlider 側で行うため、ここでは生URLの対を組むだけにする。
const IMAGE_MEDIA_WIDTH = 1280;

// SP/PC を index で対にする（片方欠けはもう片方で補完）。JS(isSP) ではなく picture の media で出し分ける。
const slides = computed(() => buildResponsiveImageSlides(props.pcImages, props.spImages));
const hasNoImage = computed<boolean>(() => slides.value.length === 0);
const hasMultipleImages = computed<boolean>(() => slides.value.length >= 2);
</script>
